import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect w="100%" selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView w="100%">
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://maps.app.goo.gl/XeB4H1eEGi8yZ3YL7"
            >
              <CFImage src={mobileMap} w="100%" alt="Tokai Ramen Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen w="100%">
            <CFLink
              target="_blank"
              w="100%"
              href="https://maps.app.goo.gl/XeB4H1eEGi8yZ3YL7"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Tokai Ramen Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
